module.exports = __webpack_public_path__ + "static/media/news-1.20af0159.webp";